import DangKyCaAnPage from "./DangKyCaAnPage";
export default DangKyCaAnPage